import type { ModelPrice } from '../types/rateLimits';
import { useApiQuery } from './useApiQuery';

const PRICE_CACHE_MS = 6 * 60 * 60 * 1000;

export function useModelPrices(enabled = true) {
  return useApiQuery<ModelPrice[]>('/usage/prices', enabled, {
    staleTime: PRICE_CACHE_MS,
    gcTime: PRICE_CACHE_MS,
  });
}
